import { AUTO_DISPATCH_POLICY_KEY as AUTO_MODE_KEY } from 'flare-chat-core/contracts/modes/mode-keys';

export function normalizeComposerModeOptions(modeOptions = []) {
  return (Array.isArray(modeOptions) ? modeOptions : [])
    .map((option) => ({
      value: String(option?.value || '').trim(),
      label: String(option?.label || option?.value || '').trim(),
    }))
    .filter((option) => option.value);
}

export function resolveComposerModeLabel(modeKey, modeOptions = []) {
  const normalized = String(modeKey || '').trim();
  if (!normalized || normalized === AUTO_MODE_KEY) {
    return '当前对话：正常聊天';
  }
  const modeOption = normalizeComposerModeOptions(modeOptions)
    .find((option) => option.value === normalized);
  return `当前对话：${modeOption?.label || normalized}`;
}
